// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'url' implicitly has an 'any' type.
function ViewProfileImage({ url, width, height }) {
  return (
    <div style={{ textAlign: "center" }}>
      <img
        style={{ maxWidth: width || "100%", maxHeight: height || "100%" }}
        src={url}
        alt="preview"
      />
    </div>
  );
}

export { ViewProfileImage };
